// Copyright (c) 2025 Ipivot Corporation.
'use strict';

import Table from 'react-bootstrap/Table';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale } from 'chart.js';
import { ProbeStatRollupItem } from '../data';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function ProbeStats({ data } : { data: any }) {
    if (!data) {
        return <div>Loading...</div>;
    }
    let disp = data.probestats.rollup;
    const cdata = {
        labels: disp.map((item: ProbeStatRollupItem) => item.type),
        datasets: [{
            label: 'Probes',
            data: disp.map((item: ProbeStatRollupItem) => item.probePassed),
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
              ],
              borderColor: [
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
              ],
              borderWidth: 1,
        }],
    }
    return (
        <Container fluid>
            <Row>
                <Col>
                    <span>Probe Count</span>
                </Col>
                <Col>
                    {data.probestats.probeCount}
                </Col>
            </Row>
            <Row>
                <Col>
                    <span>Fingerprint Count</span>
                </Col>
                <Col>
                    {data.probestats.fingerCount}
                </Col>
            </Row>
            <Row>
                <Col className="col-6 mt-4">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th colSpan={2}></th>
                                <th colSpan={3}>Probes</th>
                                <th colSpan={3}>Fingerprints</th>
                            </tr>
                            <tr>
                                <th>Run</th>
                                <th>Type</th>
                                <th>Pass</th>
                                <th>%</th>
                                <th>Fail</th>
                                <th>Pass</th>
                                <th>%</th>
                                <th>Fail</th>
                            </tr>
                        </thead>
                        <tbody>
                            {disp.map((x : any, index : number) => (
                                <tr key={index}>
                                    <td>{x.run}</td>
                                    <td>{x.type}</td>
                                    <td>{x.probePassed}</td>
                                    <td>{Math.ceil(x.probeFraction*100)}</td>
                                    <td>{x.probeFailed}</td>
                                    <td>{x.fingerprintsPassed}</td>
                                    <td>{Math.ceil(x.fingerprintsFraction*100)}</td>
                                    <td>{x.fingerprintsFailed}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
                <Col className="col-6">
                    <Pie data={cdata} options={{
                        plugins: {
                            legend: {
                                display: true
                            },
                        }
                    }}/>
                </Col>
            </Row>
        </Container>
    );
}

export default ProbeStats;